module.exports = __webpack_public_path__ + "static/media/stofferingen-33.3d783523.jpg";